import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqProdutosKit = {
	insert: async function (data) {
		return apiServer
			.post("portal/v1/produtoskit", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listKit: async function (idProduto) {
		return apiServer
			.get(`portal/v1/produto/${idProduto}/kit`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	addKit: async function (idProduto, data) {
		return apiServer
			.post(`portal/v1/produto/${idProduto}/kit`, data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	removeKit: async function (idProduto, idKit) {
		return apiServer
			.delete(`portal/v1/produto/${idProduto}/kit/${idKit}`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqProdutosKit;
